import React from 'react'
import { useSelector } from 'react-redux'
import DashboardCompanyPaymentsRow from './table-row'

import './style.scss'

const Index = () => {

    const allReceipts = useSelector(state => state.company.receipts) 
    const loading = useSelector(state => state.company.fetchReceipts.loading)

    if(!loading)

    return(
        <section className="payment-history-section">
            <div className="inner-payment-history-container">
                <table className="payments-table">
                    <thead>
                    <tr>
                        <th>Dato</th>
						<th>Abonnement</th>
                        <th>Beløp</th>
                        <th className="download">Nedlasting</th>
                    </tr>
                    </thead>
                    <tbody>
                    {allReceipts && allReceipts.length > 0 && allReceipts.map((receipt, index, arr) => {
                        return(<DashboardCompanyPaymentsRow receipt={receipt} index={index} arr={arr}/>)
                    })}
                    </tbody>
                </table>
            </div>
        </section>
    )

    return null
}

export default Index

